import React, { useState, useEffect } from 'react';
import { getFarmerPageData } from '../services/farmerService';
import { getStrapiMedia, renderSafeText } from '../lib/strapi';
import { Smartphone, CheckCircle2 } from 'lucide-react';

const Farmers = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      const result = await getFarmerPageData();
      setData(result);
      setLoading(false);
    };
    fetchData();
  }, []);

  if (loading || !data) {
    return (
      <div className="py-40 text-center flex flex-col items-center justify-center space-y-4">
        <div className="w-12 h-12 border-4 border-widya-green border-t-transparent rounded-full animate-spin"></div>
        <p className="text-gray-400 font-bold uppercase tracking-widest text-[10px]">Loading Farmer Solutions...</p>
      </div>
    );
  }

  const heroImageUrl = getStrapiMedia(data.hero_image);
  const playStoreQr = getStrapiMedia(data.play_store_url);
  const appStoreQr = getStrapiMedia(data.app_store_image);

  return (
    <div className="bg-white">
      <section className="relative overflow-hidden min-h-[60vh] lg:min-h-[85vh] flex items-center justify-center">
        {heroImageUrl ? (
          <>
            <div
              className="absolute inset-0 bg-cover bg-center bg-no-repeat"
              style={{ backgroundImage: `url(${heroImageUrl})` }}
            />
            <div className="absolute inset-0 bg-black/40" />
          </>
        ) : (
          <div className="absolute inset-0 bg-widya-green" />
        )}
        <div className="container mx-auto px-6 text-center relative z-10 w-full max-w-[1200px]">
          <h1 className="text-[46px] md:text-[64px] lg:text-[80px] font-bold tracking-tight leading-[1.1] max-w-5xl mx-auto font-heading text-white drop-shadow-lg">
            {renderSafeText(data.hero_title)}
          </h1>
        </div>
      </section>

      <section className="py-24 px-6 bg-white overflow-hidden">
        <div className="container mx-auto max-w-[1100px]">
          
          {data.hero_description && (
            <p className="text-[#333333] text-[18px] font-normal leading-[23px] tracking-[-0.5px] mt-[24px] mb-[40px] max-w-5xl mx-auto text-center">
              {renderSafeText(data.hero_description)}
            </p>
          )}

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-x-8 gap-y-20">
            {data.features_list?.map((feature, i) => (
              <div key={i} className="flex flex-col">
                <h3 className="text-[28px] font-bold text-[#67ba8e] mb-4 font-heading leading-[1.1] tracking-tight pr-2">
                  {renderSafeText(feature.title)}
                </h3>
                <p className="text-[#333333] text-[18px] font-normal leading-[23px] tracking-[-0.5px]">
                  {renderSafeText(feature.description)}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {data.app_images && data.app_images.length > 0 && (
        <section className="pb-32 px-6 bg-white">
          <div className="container mx-auto max-w-[1100px]">
            <div className="flex justify-between gap-6 flex-wrap lg:flex-nowrap">
              {data.app_images.map((img, i) => {
                const imgUrl = getStrapiMedia(img);
                return imgUrl ? (
                  <div key={img.id || i} className="w-full sm:w-[45%] lg:w-[31%]">
                    <img
                      src={imgUrl}
                      alt={`App Screenshot ${i + 1}`}
                      className="w-full h-auto object-cover"
                    />
                  </div>
                ) : null;
              })}
            </div>
          </div>
        </section>
      )}

      {(playStoreQr || appStoreQr) && (
        <section className="pb-36 px-6 bg-white">
          <div className="container mx-auto max-w-[1100px] text-center">
            <h2 className="text-[40px] font-bold leading-[48px] tracking-[-1px] text-black font-heading mb-[40px]">
              Download WIDYA Ruhuna Govinena mobile app free of charge and join.
            </h2>
            
            <div className="flex flex-wrap justify-center gap-16 items-center">
              {appStoreQr && (
                <div className="text-center">
                  <img src={appStoreQr} alt="App Store QR Code" className="w-[170px] h-auto" />
                </div>
              )}
              {playStoreQr && (
                <div className="text-center">
                  <img src={playStoreQr} alt="Google Play QR Code" className="w-[170px] h-auto" />
                </div>
              )}
            </div>
          </div>
        </section>
      )}
    </div>
  );
};

export default Farmers;